class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      /*{
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      */
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cart-drawer-header'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cart-shipping-bar-container'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cart-drawer-items'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cart-special-offers-container'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cart-drawer-footer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




if (!customElements.get('special-offer-product-form')) {
  customElements.define('special-offer-product-form', class SpecialOfferProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      //this.cartNotification = document.querySelector('cart-notification');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      //this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            //publish(PUB_SUB_EVENTS.cartError, {
            //    source: 'product-form',
            //    productVariantId: formData.get('id'),
            //    errors: response.errors || response.description,
            //    message: response.message,
            //  });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          //if (!this.error)
          //    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          
         //this.cartNotification.renderContents(response);
         // window.location = window.routes.cart_url;
         this.cart.renderContents(response);
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');    

          //Initialize Cart Countdown Timer
          InitCartCountdown();
          //Initialize Cart Free Shipping Bar
          InitCartFreeShippingBar();
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/* Custom Code - Order Protection - Starts */
if (!customElements.get('order-protection-form')) {
  //const OP_STATUS_KEY = 'op-status';
  customElements.define('order-protection-form', class OrderProtectionForm extends HTMLElement {
    constructor() {
      super();

      this.chkOrderProtection = this.querySelector('.op_switch_toggle');
      this.chkOrderProtection.addEventListener('change', this.onChangeHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var defaults = {
        namespace: null,
        key: this.chkOrderProtection.dataset.id
      };
      this.options = Object.assign({}, defaults, {});

      this.formData = {
        'items': [{
          'id': this.chkOrderProtection.dataset.id,
          'quantity': this.chkOrderProtection.dataset.quantity
        }]
      };
    }

    onChangeHandler(evt) {
      evt.preventDefault();  
      this.enableLoading(); 
      //window.localStorage.setItem(OP_STATUS_KEY, evt.target.checked);
      if(evt.target.checked) {
            this.getCart().then(function(data) {
                if (data.item_count > 0 && data.items.filter(e => e.id == this.options.key).length == 0) {
                    const config = fetchConfig('javascript');
                    if (this.cart) {
                      this.formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
                      this.formData.sections_url = window.location.pathname;
                      this.cart.setActiveElement(document.activeElement);
                    }
                    config.body = JSON.stringify(this.formData);
                    fetch(routes.cart_add_url, config)
                      .then(response => response.json())
                      .then((response) => {
                          if (response.status) {
                            return;
                          } else if (!this.cart) {
                              window.location = window.routes.cart_url;
                              return;
                          }

                          if(response.items.length > 0) {
                                response.items.forEach((responseItem) => {
                                  responseItem.sections = response.sections;
                                  this.cart.renderContents(responseItem);
                                });
                          }
                        })
                        .catch((e) => {
                          console.error(e);
                        })
                        .finally(() => {
                          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

                          this.disableLoading();
                          //Initialize Cart Countdown Timer
                          InitCartCountdown();
                          //Initialize Cart Free Shipping Bar
                          InitCartFreeShippingBar();
                        });
                }
                else if (data.item_count == 1 && data.items.filter(e => e.id == this.options.key).length == 1) {
                          this.changeItem(this.options.key, "0")
                            .then((response) => {
                                if (response.status) {
                                  return;
                                } else if (!this.cart) {
                                    window.location = window.routes.cart_url;
                                    return;
                                }

                                if(response.items.length > 0) {
                                      response.items.forEach((responseItem) => {
                                        responseItem.sections = response.sections;
                                        this.cart.renderContents(responseItem);
                                      });
                                }
                              })
                              .catch((e) => {
                                console.error(e);
                              })
                              .finally(() => {
                                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

                                this.disableLoading();
                                //Initialize Cart Countdown Timer
                                InitCartCountdown();
                                //Initialize Cart Free Shipping Bar
                                InitCartFreeShippingBar();
                              });
                }
                else {
                   
                }
            }.bind(this));
      }
      else {
            this.getCart().then(function(data) {
                if (data.item_count > 0 && data.items.filter(e => e.id == this.options.key).length > 0) {
                          this.changeItem(this.options.key, "0")
                            .then((response) => {
                                if (response.status) {
                                  return;
                                } else if (!this.cart) {
                                    window.location = window.routes.cart_url;
                                    return;
                                }

                                if(response.items.length > 0) {
                                      response.items.forEach((responseItem) => {
                                        responseItem.sections = response.sections;
                                        this.cart.renderContents(responseItem);
                                      });
                                }
                              })
                              .catch((e) => {
                                console.error(e);
                              })
                              .finally(() => {
                                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

                                this.disableLoading();
                                //Initialize Cart Countdown Timer
                                InitCartCountdown();
                                //Initialize Cart Free Shipping Bar
                                InitCartFreeShippingBar();
                              });

                }
                 else {
                 
               }
              
            }.bind(this));
      }
    }

    getCart() {
      const config = fetchConfig('javascript');
      return fetch(`${routes.cart_url}`, config).then(response => response.json());
    }

    changeItem(key, qty) {
      const config = fetchConfig('javascript');
      var changeData = {
          id: key,
          quantity: qty
        };
        if (this.cart) {
          changeData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          changeData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
      config.body = JSON.stringify(changeData);
      return fetch(`${routes.cart_change_url}`, config).then(response => response.json());
    }
  
    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

     enableLoading() {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');

      const cartDrawerOPElements = this.querySelectorAll(`.loading-overlay`);
      [...cartDrawerOPElements].forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
    }

    disableLoading() {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');

      const cartDrawerOPElements = this.querySelectorAll(`.loading-overlay`);

      cartDrawerOPElements.forEach((overlay) => overlay.classList.add('hidden'));
    }

  });
}
/* Custom Code - Order Protection - Ends */